// url: get_unique_special_client_attributes
/*
    public function getUniqueSpecialClientAttributes(): array {
        $api = (new JobConfigApi(Application::getCustomerId(), Application::getCon()));
        return [
            'unique_special_attributes' => $api->getUniqueKeysFromSpecialAttributes(),
            'unique_client_attributes' => $api->getUniqueKeysFromClientAttributes(),
        ];
    }
 */
import type { ApiInterface } from '../../../utilities/ApiInterface';
import { Api } from '@automapa/svelte-automapa-template';
import { z } from 'zod';

export const UniqueSpecialClientAttributesSchema = z.object({
    unique_special_attributes: z.array(z.string()),
    unique_client_attributes: z.array(z.string()),
});
export type UniqueSpecialClientAttributesType = z.infer<typeof UniqueSpecialClientAttributesSchema>;

export class DeliveryListSettingsApi implements ApiInterface {
    public static async getUniqueSpecialClientAttributes(
        api: Api
    ): Promise<UniqueSpecialClientAttributesType> {
        return api.getData<undefined, UniqueSpecialClientAttributesType>(
            'get',
            `/settings/get_unique_special_client_attributes`,
            undefined,
            z.undefined(),
            UniqueSpecialClientAttributesSchema
        );
    }
}
